import React from "react";
import { Megaphone, Trash2 } from "lucide-react";

export const MessageCard = ({ m, admin, onDelete }) => {
  return (
    <div
      data-testid={`message-card-${m.id}`}
      className="bg-gradient-to-br from-blue-500/10 to-[#141414] border border-blue-500/30 rounded-md p-5 relative overflow-hidden flex flex-col"
    >
      <div className="absolute top-0 right-0 w-32 h-32 bg-blue-500/10 blur-3xl rounded-full pointer-events-none" />
      <div className="relative flex flex-col h-full">
        <div className="flex items-center justify-between gap-2 mb-2">
          <span className="inline-flex items-center gap-1.5 text-[11px] font-mono px-2 py-0.5 rounded-full bg-blue-500/15 text-blue-400 border border-blue-500/20">
            <Megaphone size={12} /> MESSAGGIO
          </span>
          {admin && (
            <button
              data-testid={`delete-message-${m.id}`}
              onClick={() => onDelete && onDelete(m.id)}
              className="p-1.5 rounded-md text-zinc-500 hover:text-red-400 hover:bg-red-500/10 transition-colors"
              title="Elimina messaggio"
            >
              <Trash2 size={15} />
            </button>
          )}
        </div>
        <h3 className="text-base font-semibold text-white">{m.title}</h3>
        <p className="text-sm text-zinc-300 mt-2 whitespace-pre-wrap leading-relaxed flex-1">{m.body}</p>
        <div className="text-[11px] text-zinc-600 mt-4 font-mono">
          {m.created_at && new Date(m.created_at).toLocaleString("it-IT", { timeZone: "Europe/Rome" })}
        </div>
      </div>
    </div>
  );
};
